import React from 'react';
import style from './block.module.scss';
import { BlockWrapper, defineBlock, useEditor, useChildrenBlocks } from '@smartfire/js-block-engine';
import { ReactComponent as SmartfireIcon } from '../assets/smartfire_icone.svg';

function Block() {
    const { isEditing } = useEditor();
    const { Children } = useChildrenBlocks();
    return (
        <BlockWrapper.Div className={style.block}>
            {isEditing && <div className={style.header}>Contenu de page</div>}
            <div className={style.content}>
                <Children
                    gutenbergEditorConfig={{
                        allowedBlocks: ['core/paragraph', 'core/list', 'core/heading'],
                        allowedFormats: ['core/link'],
                    }}
                />
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block,
    setup: {
        title: 'Contenu de page',
        icon: SmartfireIcon,
    },
});
